import React from 'react';

import { observer } from 'mobx-react';
import { LinearStepper, LinearStepOption } from '@infoods/lifebase-ui';

import { useStepper } from '../../../../../shared/hooks/useStepper';
import { PersonalInfoStep } from './PersonalInfoStep/PersonalInfoStep';
import { SelectSubscription } from '../../components/SelectSubscription/SelectSubscription';
import { SelfBillingPlanStep } from './SelfBillingPlanStep/SelfBillingPlanStep';
import { entitySignUpStore } from '../../../../../shared/stores/entity/entitySignUpStore';

const CreateCustomerStep = observer(() => {
  const { activeStep, goToNextStep } = useStepper();
  const { scanIqBillingTypeFlags } = entitySignUpStore;

  const planStep: LinearStepOption = scanIqBillingTypeFlags.SELF_BILLING
    ? {
        title: 'Your subscription is ready',
        description: 'Confirm your plan and proceed to start your InBody scan',
        step: <SelfBillingPlanStep />,
      }
    : {
        title: 'Select a plan below that fits your needs',
        description: 'Select a subscription and proceed to the checkout with Stripe',
        step: <SelectSubscription />,
      };

  const stepsConfig: LinearStepOption[] = [
    {
      title: "We couldn't find an account for you",
      description:
        'Please fill in your personal information to create a profile and start your first InBody scan. All fields are required.',
      step: <PersonalInfoStep onCustomerCreated={goToNextStep} />,
    },
    planStep,
  ];

  return (
    <LinearStepper label="User Form" activeStep={activeStep} stepsConfig={stepsConfig} />
  );
});

export { CreateCustomerStep };
